import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { BillingStatementForm } from '@/components/forms/BillingStatementForm'
import {
  shippingLineNameFromSearchParams,
  soaIdFromSearchParams,
} from '@/lib/navigation/financialStatementsSearchParams'

export default function CreateBillingPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const paramsShippingLineId = useParams<{ shippingLineId: string }>().shippingLineId

  const shippingLineName = shippingLineNameFromSearchParams(searchParams)
  const finalShippingLineId = paramsShippingLineId
  const finalSoaId = soaIdFromSearchParams(searchParams)

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Create Billing Statement
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Create a new Billing Statement
            </Text>
          </CardHeader>
          <CardBody>
            <BillingStatementForm
              soaId={finalSoaId}
              registeredName={shippingLineName}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
